import initState from './initState';

export const loadState = () => {
  try {
    const serialisedState = localStorage.getItem('noodled-state');
    if (serialisedState === null) {
      return initState;
    }
    return JSON.parse(serialisedState);
  } catch (error) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serialisedState = JSON.stringify(state);
    localStorage.setItem('noodled-state', serialisedState);
  } catch (error) {
    console.warn(error);
  }
};



// WEBPACK FOOTER //
// ./src/state-store/localStorage.js